import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error Boundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-gradient-to-br from-blue-900 via-blue-950 to-black flex items-center justify-center p-6">
          <div className="bg-white/5 backdrop-blur-lg border border-white/10 rounded-2xl p-8 shadow-2xl max-w-md w-full text-center">
            <div className="text-red-400 text-6xl mb-4">⚠️</div>
            <h2 className="text-2xl font-bold text-white mb-4 font-orbitron">Something went wrong</h2>
            <p className="text-white/70 mb-6">
              There was an error loading the swap interface. This might be due to:
            </p>
            <ul className="text-left text-white/60 text-sm mb-6 space-y-2">
              <li>• Multiple wallet extensions conflicting</li>
              <li>• Network connection issues</li>
              <li>• Contract loading problems</li>
            </ul>
            <button
              onClick={() => window.location.reload()}
              className="w-full px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-xl font-semibold transition-colors duration-200"
            >
              Reload Page
            </button>
            <p className="text-white/40 text-xs mt-4">
              Try disabling other wallet extensions if the problem persists
            </p>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;